import cx from 'classnames';
import styles from './Pane.module.scss';

type PaneProps = {
  children: React.ReactNode;
  className?: string;
  collapsed?: boolean;
  id: string;
};

const Pane = function Pane({ children, className, collapsed, id }: PaneProps) {
  return (
    <div
      id={id}
      className={cx(
        styles.pane,
        {
          [styles.collapsed]: collapsed,
        },
        className,
      )}
    >
      {children}
    </div>
  );
};

export default Pane;
